import React, {useState} from "react";
import {useDispatch} from "react-redux";
import ScrollArea from 'react-scrollbar';
import {Col, FormGroup, Row} from "reactstrap";
import Select from "react-select";
import {setOrderFilter} from "../store/orderSlice";
import Switch from "react-switch";


export default function OrderFilter(props) {
    const dispatch = useDispatch();
    const {orderState, clearSelectAll, customStyles,paymentTypeOptions, setPaymentType, setCountry, setFilterValues, setOrderType, setShippingType,setRemoteIsland,remoteIsland, orderTypeOptions, unallocatedShipping, setUnallocatedShipping, setPartner, isDisabled} = props;

    const claimStatus = [
        { id: 0, name: "Won" },
        { id: 1, name: "Loss" },
        { id: 2, name: "Decision Pending" },
    ];

    document.addEventListener("mousedown", (event) => {
        const concernedElement = document.querySelector(".customizer-contain");
        if(concernedElement) {
            if (!concernedElement.contains(event.target)) {
                document.querySelector(".customizer-contain").classList.remove('open');
            }
        }
    });

    const [checked, setChecked] = useState(remoteIsland);
    const [checkedUnallocatedShipping, setCheckedUnallocatedShipping] = useState(unallocatedShipping);



    const handleChange = nextChecked => {
        dispatch(setOrderFilter({
            ...orderState.filter,
            remote_island:nextChecked
        }));
        setRemoteIsland(nextChecked)
        clearSelectAll();
        setChecked(nextChecked);
    }

    const unallocatedShippingHandleChange = nextChecked => {
        dispatch(setOrderFilter({
            ...orderState.filter,
            unallocated_shipping:nextChecked,
            financialStatus: nextChecked ? { value: "paid", label: "paid" } : null,
            status: nextChecked
              ? { value: "unfulfilled", label: "unfulfilled" }
              : null,
        }));
        setUnallocatedShipping(nextChecked)
        clearSelectAll();
        setCheckedUnallocatedShipping(nextChecked);
    }

    const unallocatedSellerHandleChange = nextChecked => {
        dispatch(setOrderFilter({
            ...orderState.filter,
            unallocated_seller:nextChecked,
            financialStatus: nextChecked ? { value: "paid", label: "paid" } : null,
            status: nextChecked
              ? { value: "unfulfilled", label: "unfulfilled" }
              : null,
        }));
    }

    const trackingDetailsHandleChange = nextChecked => {
        dispatch(setOrderFilter({
            ...orderState.filter,
            havingTrackingDetails:nextChecked
        }));
    }

    const havingErrorsHandleChange = nextChecked => {
        dispatch(setOrderFilter({
            ...orderState.filter,
            having_errors:nextChecked
        }));
    }

    const orderStuckHandleChange = nextChecked => {
        dispatch(setOrderFilter({
            ...orderState.filter,
            order_stuck:nextChecked
        }));
         clearSelectAll();
    }

    const testOrderHandleChange = nextChecked => {
        dispatch(setOrderFilter({
            ...orderState.filter,
            testOrders : nextChecked,
        }));
    }
    const subscribeOrdersHandleChange = nextChecked => {
        dispatch(setOrderFilter({
            ...orderState.filter,
            subscribeOrders : nextChecked,
        }));
    }

    // GOD-TK-128: orders with at least one open line of an integrated seller that never reached the brand store
    const notSyncedSellerStoreHandleChange = nextChecked => {
        dispatch(setOrderFilter({
            ...orderState.filter,
            not_synced_seller_store : nextChecked,
        }));
        clearSelectAll();
    }

    const sortedShippingTypes = [...orderState.settings.shippingType]
    .sort((a, b) => a.name.localeCompare(b.name));

    return (
        <>
            <style>
                {`
                    @media (max-height: 768px) {
                        .custom-scrollarea {
                            position: relative; 
                            min-height: 500px !important;
                            height: 100%;
                        }
                    }
                `}
            </style>
            <div style={{ height: "1000px" }}>
                <ScrollArea
                    horizontal={false}
                    vertical={true}
                    className="custom-scrollarea"
                >
                    <Row>
                        <Col md={6} className="mt-3">

                            <Select
                                getOptionLabel={(option) => option.name}
                                    className="select2-filter"
                                    menuPortalTarget={document.body}
                                    styles={{menuPortal: base => ({...base, zIndex: 100})}}
                                    value={orderState.filter.payment_type}
                                    getOptionValue={(option) => option.id}
                                    onChange={(e) => {
                                        dispatch(setOrderFilter({
                                            ...orderState.filter,
                                            payment_type:e
                                        }));
                                       
                                        clearSelectAll();

                                    }}
                                    isClearable={true}
                                    placeholder="Payment type"
                                    components={{
                                        IndicatorSeparator: () => null
                                    }}
                                    options={paymentTypeOptions}
                                    isDisabled={isDisabled}/>
                        </Col>
                        <Col md={6} className="mt-3">
                            <Select
                                getOptionLabel={(option) => option.name}
                                className="select2-filter"
                                menuPortalTarget={document.body}
                                styles={{menuPortal: base => ({...base, zIndex: 100})}}
                                value={orderState.filter.country}
                                getOptionValue={(option) => option.id}
                                onChange={(e) => {
                                    dispatch(setOrderFilter({
                                        ...orderState.filter,
                                        country:e
                                    }));
                                    
                                    clearSelectAll();

                                }}
                                isClearable={true}
                                placeholder="Country"
                                components={{
                                    IndicatorSeparator: () => null
                                }}
                                options={orderState.settings.countries}
                                isDisabled={isDisabled}/>
                        </Col>
                        <Col md={6} className="mt-3">
                            <Select
                                getOptionLabel={(option) => option.name}
                                className="select2-filter"
                                menuPortalTarget={document.body}
                                styles={{menuPortal: base => ({...base, zIndex: 100})}}
                                value={orderState.filter.shipping_type}
                                getOptionValue={(option) => option.id}
                                onChange={(e) => {
                                    dispatch(setOrderFilter({
                                        ...orderState.filter,
                                        shipping_type:e
                                    }));
                                    
                                    clearSelectAll();

                                }}
                                isClearable={true}
                                placeholder="Shipping Types"
                                components={{
                                    IndicatorSeparator: () => null
                                }}
                                options={sortedShippingTypes}
                                isDisabled={isDisabled}/>
                        </Col>
                        <Col md={6} className="mt-3">
                            <Select
                                getOptionLabel={(option) => option.name}
                                className="select2-filter"
                                menuPortalTarget={document.body}
                                styles={{menuPortal: base => ({...base, zIndex: 100})}}
                                value={orderState.filter.order_type}
                                getOptionValue={(option) => option.id}
                                onChange={(e) => {
                                    dispatch(setOrderFilter({
                                        ...orderState.filter,
                                        order_type:e
                                    }));
                                   
                                    clearSelectAll();

                                }}
                                isClearable={true}
                                placeholder="Order Types"
                                components={{
                                    IndicatorSeparator: () => null
                                }}
                                options={orderTypeOptions}
                                isDisabled={isDisabled}/>
                        </Col>
                        <Col md={6} className="mt-3">
                            <Select
                                getOptionLabel={(option) => option.name}
                                className="select2-filter"
                                menuPortalTarget={document.body}
                                styles={{menuPortal: base => ({...base, zIndex: 100})}}
                                value={orderState.filter.partner}
                                getOptionValue={(option) => option.id}
                                onChange={(e) => {
                                    dispatch(setOrderFilter({
                                        ...orderState.filter,
                                        partner:e
                                    }));
                                    
                                    clearSelectAll();

                                }}
                                isClearable={true}
                                placeholder="Partners"
                                components={{
                                    IndicatorSeparator: () => null
                                }}
                                options={orderState.settings.partner}
                                isDisabled={isDisabled}
                                />
                        </Col>
                        <Col md={6} className="mt-3">
                            <Select
                                placeholder={<div>Claim Status</div>}
                                getOptionLabel={(option) => option.name}
                                getOptionValue={(option) => option.id}
                                className="select2-filter"
                                isClearable
                                menuPortalTarget={document.body}
                                styles={{menuPortal: base => ({...base, zIndex: 100})}}
                                options={claimStatus}
                                onChange={(e) => {
                                    dispatch(setOrderFilter({
                                        ...orderState.filter,
                                        claimStatus:e
                                    }));
                                    
                                    clearSelectAll();

                                }}
                            />
                        </Col>
                        <Col md={6} className="mt-3">
                            <Select
                                getOptionLabel={(option) => option.name}
                                isMulti={true}
                                className="select2-filter"
                                menuPortalTarget={document.body}
                                styles={{menuPortal: base => ({...base, zIndex: 100})}}
                                value={Array.isArray(orderState.filter.tags) ? orderState.filter.tags : []}
                                getOptionValue={(option) => option.id}
                                filterOption={(option, inputValue) =>
                                    option.data.name.toLowerCase().includes(inputValue.toLowerCase())
                                }
                                onChange={(e) => {
                                    dispatch(setOrderFilter({
                                        ...orderState.filter,
                                        tags: e && e.length > 0 ? e : ""
                                    }));
                                    clearSelectAll();
                                }}
                                placeholder="Select Tags"
                                components={{
                                    IndicatorSeparator: () => null
                                }}
                                options={orderState.settings.tags || []}
                                isDisabled={isDisabled}
                            />
                        </Col>
                    </Row>
                    <Row className="mt-4">
                        <Col md={6}>
                            <div className="d-flex align-items-center mb-3">
                                <Switch
                                    checked={orderState.filter.remote_island}
                                    onChange={handleChange}
                                    className="react-switch"
                                    uncheckedIcon={false}
                                    checkedIcon={false}
                                    disabled={isDisabled}
                                />
                                <label className="mb-0 ml-2">Remote Island</label>
                            </div>
                            <div className="d-flex align-items-center mb-3">
                                <Switch
                                    checked={orderState.filter.unallocated_seller}
                                    onChange={unallocatedSellerHandleChange}
                                    className="react-switch"
                                    uncheckedIcon={false}
                                    checkedIcon={false}
                                    disabled={isDisabled}
                                />
                                <label className="mb-0 ml-2">Unallocated Seller</label>
                            </div>
                            <div className="d-flex align-items-center mb-3">
                                <Switch
                                    checked={orderState.filter.havingTrackingDetails}
                                    onChange={trackingDetailsHandleChange}
                                    className="react-switch"
                                    uncheckedIcon={false}
                                    checkedIcon={false}
                                    disabled={isDisabled}
                                />
                                <label className="mb-0 ml-2">Tracking Details</label>
                            </div>
                            <div className="d-flex align-items-center mb-3">
                                <Switch
                                    checked={orderState.filter.having_errors}
                                    onChange={havingErrorsHandleChange}
                                    className="react-switch"
                                    uncheckedIcon={false}
                                    checkedIcon={false}
                                    disabled={isDisabled}
                                />
                                <label className="mb-0 ml-2">Having Errors</label>
                            </div>
                            <div className="d-flex align-items-center mb-3">
                                <Switch
                                    checked={orderState.filter.unallocated_shipping}
                                    onChange={unallocatedShippingHandleChange}
                                    className="react-switch"
                                    uncheckedIcon={false}
                                    checkedIcon={false}
                                    disabled={isDisabled}
                                />
                                <label className="mb-0 ml-2">Unallocated Shipping Orders</label>
                            </div>
                        </Col>
                        <Col md={6}>
                            <div className="d-flex align-items-center mb-3">
                                <Switch
                                    checked={orderState.filter.order_stuck}
                                    onChange={orderStuckHandleChange}
                                    className="react-switch"
                                    uncheckedIcon={false}
                                    checkedIcon={false}
                                    disabled={isDisabled}
                                />
                                <label className="mb-0 ml-2">Order stuck for more than 2 days</label>
                            </div>
                            <div className="d-flex align-items-center mb-3">
                                <Switch
                                    checked={orderState.filter.testOrders}
                                    onChange={testOrderHandleChange}
                                    className="react-switch"
                                    uncheckedIcon={false}
                                    checkedIcon={false}
                                    disabled={isDisabled}
                                />
                                <label className="mb-0 ml-2">Test Order</label>
                            </div>
                            <div className="d-flex align-items-center mb-3">
                                <Switch
                                    checked={orderState.filter.subscribeOrders}
                                    onChange={subscribeOrdersHandleChange}
                                    className="react-switch"
                                    uncheckedIcon={false}
                                    checkedIcon={false}
                                    disabled={isDisabled}
                                />
                                <label className="mb-0 ml-2">Subscriber's Orders</label>
                            </div>
                            <div className="d-flex align-items-center mb-3">
                                <Switch
                                    checked={orderState.filter.not_synced_seller_store}
                                    onChange={notSyncedSellerStoreHandleChange}
                                    className="react-switch"
                                    uncheckedIcon={false}
                                    checkedIcon={false}
                                    disabled={isDisabled}
                                />
                                <label className="mb-0 ml-2">Not synced with seller store</label>
                            </div>
                        </Col>
                    </Row>
                </ScrollArea>
            </div>
        </>
    )
}
